<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="detailItem"
                            @delete-items="deleteItems"
                            @clone-master="showModalClone"
                            ref="gofixTable">
                            <template slot="gofix_table:repeat_hours" slot-scope="row">
                                {{ row.item.repeat_hours ? `${row.item.repeat_hours}h` : null}}
                            </template>
                            <template slot="gofix_table:repeat_end_times" slot-scope="row">
                                {{ row.item.repeat_end_times ? `${row.item.repeat_end_times} ${row.item.repeat_end_times > 1 ? 'times' : 'time'}` : null}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <b-modal :no-close-on-backdrop="true" @hidden="hideModelCreate" 
                id="modal-Clone"
                modal-class="default-modal modal-clone-notification"
                title="Clone Master"
                :centered="true"
                scrollable
                :footer-class="'border-0'"
                @shown="getMasterNotificationTemplates"
                v-model="modals.clone.open">
            <b-form v-if="modals.clone.list.length && !modals.clone.first">
                <ul class="listCheck list-unstyled listData">
                    <li>
                        <input class="styled-checkbox" type="checkbox" v-model="modals.clone.allSelect">
                        <label></label>
                        <span class="pl-25">Module</span>
                    </li>
                    <template  v-for="(cl, index) in modals.clone.list">
                        <li :key="index">
                            <input v-model="modals.clone.select" class="styled-checkbox" type="checkbox" :value="cl.id">
                            <label></label>
                            <span>{{index + 1}}</span>
                            <span>{{cl.module}} - {{cl.event_trigger_name}} - {{cl.medium}}</span>
                        </li>
                    </template>
                </ul>
            </b-form>
            <div class="pb-20 text-center" v-if="!modals.clone.list.length && !modals.clone.first">
                No Master!
            </div>
            <template #modal-footer>
                <b-button-group class="d-block text-right pr-3">
                    <gofix-button label="SUBMIT" @click="cloneDataFromMater" :loading="modals.clone.loading" noBorder></gofix-button>
                </b-button-group>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    export default {
        name: 'lmu-notification',
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['lmu_notification']));
            return {
                tableConfig:{
                    name: 'lmu-notification-template',
                    controls:{
                        tableCloneMaster: true,
                        create: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: []
                },
                tableItems:[],
                modals: {
                    clone: {
                        open: false,
                        allSelect: false,
                        list:[],
                        select:[]
                    }
                }
            }
        },
        watch: {
            "modals.clone.allSelect": function(val) {
                if (val) {
                    this.modals.clone.select = [];
                    for (let i in this.modals.clone.list) {
                        this.modals.clone.select.push(this.modals.clone.list[i].id)
                    }
                }
                if(!val && this.modals.clone.list.length == this.modals.clone.select.length) {
                    this.modals.clone.select = [];
                }
            },
            "modals.clone.select": function(val) {
                if(this.modals.clone.select.length > 0 && this.modals.clone.list.length === this.modals.clone.select.length) {
                    this.modals.clone.allSelect = true;
                }else{
                    this.modals.clone.allSelect = false;
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            })
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(!tableRequest.filter.contract_id.value) {
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    resolve({ items: [], total: 0 });
                    return;
                }
                tableRequest.filter.module_use.value = 'LMU-Adhoc';
                await this.$store.dispatch("NotificationTemplateController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of notification templates", "danger");
                        reject();
                    })
            },
            detailItem(item) {
                this.$router.push(`/v2/lmu-notification/${item.id}`).catch(err => {})
            },
            async deleteItems(callback) {
                const {ids, filter, resolve, reject} = await callback();
                this.$store.dispatch("NotificationTemplateController/deleteItems", ids)
                    .then(response => {
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        reject(err);
                    });
            },
            hideModelCreate(){
                this.modals.clone.allSelect = false;
                this.modals.clone.select    = [];
                this.modals.clone.list      = [];
            },
            showModalClone() {
                this.getMasterNotificationTemplates();
                this.modals.clone.open = true;
            },
            getMasterNotificationTemplates() {
                this.$store.dispatch("NotificationTemplateController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                    isCMS: 1,
                    filter: {
                        contract_id: { type: "null", value: null, function: "=", with: [] },
                        module_use: { type: "text", value: "LMU-Adhoc", function: "ilike", with:[] }
                    }
                })
                .then(response => {
                    this.modals.clone.list = response.data.data.items;
                })
                .catch(err => { })
            },
            cloneDataFromMater() {
                if(!this.ClientContractID || !this.ClientContractID.id){
                    return this.$alertNotification("Please choose contract!",'danger');
                }
                this.modals.clone.loading = true;
                let data = {
                    contract_id: this.ClientContractID.id,
                    ids: this.modals.clone.select,
                };
                this.$store.dispatch("NotificationTemplateController/cloneTemplate",data)
                .then(response => {
                    this.$alertNotification("Successfully Clone");
                    this.modals.clone.open = false;
                    this.modals.clone.loading = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(error => {
                    let msg = "Clone failed!";
                    if(error.response.data && error.response.data.error && error.response.data.error.message && error.response.data.error.message.error) {
                        msg = error.response.data.error.message.error;
                    }
                    this.$alertNotification(msg, "danger");
                    this.modals.clone.loading = false;
                })
            }
        }
    }
</script>